export const translations = {
  en: {
    nav: {
      sections: {
        whyUs: "why us?",
        products: "products",
        solutions: "solutions",
        resources: "resources",
        contact: "contact us",
      },
      items: {
        ourCompany: "Our company",
        ourMission: "Our mission",
        treasury: "Treasury",
        virtualAccounts: "Virtual Accounts",
        eWallets: "E-Wallets",
        invoiceQr: "Invoice-QR Integration",
        b2bPayments: "B2B Payments",
        orderToCash: "Order to Cash",
        recordToReport: "Record to Report",
        cashManagement: "Cash Management",
        accountPayables: "Account Payables",
        useCases: "Use Cases",
      },
      openMenu: "Open menu",
      closeMenu: "Close menu",
      toggleLanguage: "Toggle language",
    },
    common: {
      product: "Product",
      talkToExpert: "Talk to our expert",
      contactUs: "Contact Us",
      writeMessage: "Write a Message",
      sendMessage: "Send Message",
      subscribe: "Subscribe",
    },
    banner: {
      slides: [
        "Never worry about cash flow again",
        "Make payments seamlessly",
        "Automate supply chain payments",
        "Reconcile as you transact",
        "Master corporate financial health",
        "Trade with ethical finance",
      ],
      ctaTalk: "Talk To Our Expert",
      ctaProducts: "Products",
    },
    home: {
      sectionLabel: "What We Do",
      title:
        "One stop solution for all your corporate payment, collection, working capital and cash management requirements.",
      desc1:
        "Trusted by multiple companies to manage and automate transactions on their behalf, returning substantial time efficiencies and cost savings.",
      desc2:
        "Our solutions reduce the cost of transactions, eliminate fraud, and let you focus on your strategic operations at peace.",
      tabProducts: "Products",
      tabSolutions: "Solutions",
      ctaUseCases: "Success cases across industries",
      ctaTalk: "Talk to our expert",
      cards: {
        treasuryTitle: "Treasury",
        treasuryDesc: "Run your business with total financial clarity.",
        vaTitle: "Virtual Accounts",
        vaDesc:
          "Gain your full control of corporate payments with real-time recognition.",
        invoiceTitle: "Invoice QR Integration",
        invoiceDesc: "Reconcile as you transact.",
        walletsTitle: "e-Wallets",
        walletsDesc: "Master your payables and spend.",
        s1Title: "B2B Payments",
        s1Desc: "Payments Gateway Merchant Management System Virtual Accounts.",
        s2Title: "Order to Cash",
        s2Desc:
          "Faster collections and reconciliation at lower cost Credit management.",
        s3Title: "Record to Report",
        s3Desc:
          "Financial close management Real-time reconciliation Anomaly management.",
        s4Title: "Cash Management",
        s4Desc:
          "Completely automated daily cash positions. Optimize your debt, investments and multi-currency accounts on a single click.",
        s5Title: "Account Payables",
        s5Desc:
          "Never miss a payment with payments setup with the system, integrated with your ERP. Pay to any bank from a single portal.",
      },
    },
    company: {
      label: "Our Company",
      title: "We make your money work more for you",
      p1: "IP Payment Solutions is a Bank of Thailand licensed payment service provider, with licenses for e-money, bill payments, payment gateway and e-money transfer. These licenses allow our business to provide and operate escrow accounts to customers, manage payments and collections on behalf of our customers, and consolidate transfers across these accounts.",
      p2: "We function like a bank regulated by Bank of Thailand, providing corporates seamless, data driven transaction transparency with instant reconciliation. Our single-minded focus is to help organizations gain efficiency and improve decision making multifold but giving them real-time visibility of their cash flows and cash forecasts - substantially enhancing their working capital positions.",
    },
    mission: {
      label: "Our Mission",
      title:
        "Automate supply chain finance and digitize organizational AR and AP processes to support the CFO in focusing on business growth strategy.",
      subtitle:
        "Our solutions drive the following benefits in organizations of every size and complexity.",
      benefits: [
        "Simplify AR and reconciliation.",
        "Optimize working capital - collect first from end customer, disburse later.",
        "Get a single view of cash - Manage cash and forecast better.",
        "Use cash wisely - 100% cash visibility for better debt and investment planning.",
        "Simplified AP - Entire payment lifecycle workflow for ALL BANKS in a single solution.",
        "Reduce bank fees with our closed loop ecosystem with partner banks.",
        "Reduce operational overheads - Automate GL, approvals, reports. No cheques, no messengers.",
      ],
    },
    products: {
      treasury: {
        title: "Treasury",
        subtitle: "Run your business with total financial clarity",
        p1: "How many banks do you bank with? How many accounts across your family trusts, your holding company and your subsidiaries? How many sources to collect AR and AP information? Now imagine all of that information with real-time forecasts in one place. Imagine the time saved. Imaging efficiencies achieved. Imagine the clarity with which you can operate your business. We return 60% savings in accounting time alongwith substantial cost savings.",
        p2: "Our virtual accounts integrate with our treasury management system under our parent company Flybridge, which integrates all your banks, bank accounts, virtual accounts and associated transaction data in one place. It also integrates with your ERP. Meaning, when you login every morning, you have clear visibility of your cash flows - wherever you login from!",
      },
      virtualAccounts: {
        title: "Virtual Accounts",
        subtitle:
          "Gain full control of corporate payments with real-time reconciliation.",
        p1: "Have your entire supply chain on the same payment system, the equivalent of bank accounts, but with the ability to have details behind every transaction. Who paid, for what, when and how much.",
        p2: "Accounting teams typically end up taking days reconciling invoices against payments. Thailand has one of the highest numbers of workforce in the accounting and finance teams. That all changes with your virtual account. You now have the ability to create payment workflows which automatically transfer to a checker from maker, and to the approver from a checker. No more tokens, with the same amount of security.",
        p3: "Reduce error and fraud in transactions drastically by removing paper handoffs, random approvals, back and forth emails, and waiting on messengers to get payments signed off.",
      },
      invoiceQr: {
        title: "Invoice QR Integration",
        subtitle: "Invoice Payments, Instant Invoice Reconciliation",
        p1: "How do you send invoices today? With bank account details? And when do you know when you received the money owed? When accounts team finally reconciles all accounts receivables? And what if you realized you didn't receive the money after all? Then you start chasing the customers for payments. Imagine the amount of time, effort, and cash you lost out on - which you could save by one easy integration - embedded QR or payment link on the invoice.",
        p2: "What is so great about it? The fact that such payments then come with a reference. Which means you know who paid and who didn't, instantaneously. Take control of your cash today.",
      },
      eWallets: {
        title: "E-Wallets",
        subtitle: "Reconcile as you transact",
        p1: "Make it easier to transact with the ability to top-up, transfer, withdraw money across your ecosystem - be it payroll for employees or within your close community.",
        p2: "Now you can transfer money to your employees - be it any nationality, on a single click. No more paying cash or writing cheques, no more approvals on paper, no more tokens to authorize payments. A simple elegant way to pay your employees, with an ability to send out notifications related to your business. You can also whitelabel the wallet to your own brand!",
        p3: "As an individual, ease of paying bills and holding a Thai bank account irrespective of your nationality.",
        p4: "Heaven for tourists who are tired of paying heavy bank fees in withdrawing cash or paying with their credit cards. Top-up your wallet and have the freedom of spending in Thailand - fully compliant with Bank of Thailand regulations.",
      },
    },
    solutions: {
      label: "What We Offer",
      title: "Solutions",
      b2b: {
        title: "B2B Payments",
        p1: "Payment Gateway - Integrate payments with ease on your website, your POS device or your EDC devices, with some of the best rates in the market. Secure electronic payment processing. We also provide a range of POS and EDC devices.",
        p2: "Merchant Management System - Manage payments, settlements, reconciliation at the most competitive rates available in Thailand. Have full visibility of all transactions, manage refunds and settlements with ease.",
        p3: "Virtual Accounts - Pay directly to other Virtual Accounts within IPPS provided ecosystem, or to other banks on a single click.",
      },
      orderToCash: {
        title: "Order to Cash",
        subtitle: "Reduce leverage, Collect efficiently",
        p1: "Faster collections and reconciliation at lower cost - Send invoices with QR codes or bank transfer links to ensure every collection comes with a payment reference and is accounted for against invoices raised. Reduce collection costs and carbon footprint by 30% from day 1.",
        p2: "Credit management - Manage credit with customers better to ensure they pay in time, or charge interest in agreement with them for delayed payments. Maybe propose early payments in lieu of discounts if you need cash, rather than taking bank overdrafts. Whichever way, our partner solutions help you to record transactions effectively, while creating general ledger entries as you transact, keeping your books clean effortlessly. Seamlessly manage credit across your ecosystem.",
      },
      recordToReport: {
        title: "Record to Report",
        subtitle: "Close your books in days instead of weeks.",
        p1: "Financial close management - Total account reconciliation with automated GL reporting to ensure a smooth month-end close. Reduce days to close by at-least 50%.",
        p2: "Real-time reconciliation - Payments made with references help you ensure you reconcile real-time. Payments on our system give you details on who paid for what, and when. You can input invoice details in the payment reference, or any other reference required for you to reconcile.",
        p3: "Anomaly management - Validate payments before accepting them, AI/ML driven rule based checks. The system lists any anomalies that sit outside the rule based parameters. Reduce fraud by 90%.",
      },
      cashManagement: {
        title: "Cash Management",
        subtitle: "Manage your working capital like a pro.",
        p1: "To manage cash effectively - financial controllers need real-time visibility from of cash from all quarters of your business. This means a pulse check across subsidiaries, across departments, across banks, payables and receivables every single day. Our solutions make this data available at your fingertips, customized to your business workflows.",
        p2: "Completely automated daily cash positions - Optimize your debt, investments and multi-currency accounts on a single click. Hands-free cash reconciliation to increase productivity by 70%.",
      },
      accountPayables: {
        title: "Account Payables",
        p1: "De-centralise payables with defined authority limits across functions while still retaining full control and transparency with our parent-child accounts. Never miss a payment with payments setup with the system, integrated with your ERP. Pay to any bank from a single portal.",
      },
    },
    usecases: {
      label: "Industry Focus",
      title: "Use Cases",
      subtitle:
        "Discover how our payment solutions transform businesses across diverse industries.",
      list: {
        international: {
          title: "International Collections and Payments",
          p1: "Collect from your Thai customers and pay your Thai suppliers without a Thai bank account. Open an account with IPPS. We manage the rest. Our customers have reduced cost of transactions, made is easy for their customers to pay them, with real-time clarity of their collections.",
          automate: [
            "Supply chain payments",
            "Payroll",
            "Tax deduction",
            "Payment instructions",
            "Reconciliation",
            "Forecasts",
            "General ledger",
          ],
          reduce: ["Bank fees", "Operational costs", "Fraud"],
          achieve: [
            "Transparency",
            "Time savings",
            "Cost savings",
            "Strategic decision-making capability",
            "ESG benefits",
          ],
        },
        tourism: {
          title: "Tourism and Hospitality",
          p1: "Make your customers' dream holiday sweeter. Provide them e-wallets to pay easily within your resorts, integrate with the keys, enable payments in the associated ecosystem.",
          p2: "Enable rule based payments to your suppliers whereby money automatically gets setup for payments from receivables, and you can make a single click approval to clear all your AP.",
        },
        finance: {
          title: "Finance and Lending",
          p1: "It is important as a financier/lender to know your money in the lendee's supply chain is secure, and you are the first beneficiary of the end customer payments, not your lendee.",
          p2: "Virtual accounts setup with our ecosystem enable you to lend money with full visibility of the funds. Rule based collections ensure that when the lendee receives the money from end customer first, it goes into an escrow with us, you get paid and remaining balance goes to the lendee.",
        },
        manufacturing: {
          title: "Manufacturing and Automotive",
          p1: "Manage seamless payments across your supply chain. Structure early/late payments depending on the need of the hour, in agreement with your suppliers with in-house banking solutions. Setup departmental budgets in designated virtual accounts with clear visibility of the cash utilization across board, while having an aggregated view at a group level. The possibilities of customizing the flow of payments with virtual accounts are endless.",
        },
        oil: {
          title: "Oil and Gas",
          p1: "Exploration fields take you to remote places, and with it, you need to support remote, local payments. Leverage our payments ecosystem supported with cross border payment partners to have a seamless payment ecosystem, with structured payments and reconciliation across your supply chain.",
        },
        retail: {
          title: "Retail and Consumer Goods",
          p1: "Manage rental payments from shop owners in the mall with full visibility of transactions as well as your dues.",
        },
        ecommerce: {
          title: "e-Commerce",
          p1: "Integrate with IPPS Payment Gateway and collect payments seamlessly on any of your sales channels, be it your website, application or invoice. Our payment solution can be integrated with your invoices for customers to transfer funds with reference - so you can reconcile payments real-time. Beyond this, you can enable payments across your supply chain, with clear visibility of all transactions real-time.",
        },
        transport: {
          title: "Transport and Logistics",
          p1: "Manage collections for every completed job, real-time. Enable driver wallets to make payroll and miscellaneous payments to your drivers. Digitise payments and collections across your ecosystem - right from the truck rental, to garages, to customers in one single ecosystem.",
        },
        foreignWorker: {
          title: "Foreign Worker Inclusion & Payroll",
          p1: "Every unbanked person can open a wallet account with us, with ability to make payments and collect funds and payroll straight from and to the wallet. Corporates can make payroll to contract workers as well, with managed withholding tax.",
        },
        thaiCorp: {
          title: "Thai Corporations and Family Offices",
          p1: "Simplify cash visibility across banks, accounts, subsidiaries and supply chain, with real time:",
          bullets: [
            "Payments",
            "Settlements",
            "Reconciliation",
            "Cash forecasts",
            "Reporting",
            "Accounting",
          ],
        },
        ipo: {
          title: "Planning an IPO",
          p1: "Line your ducks in a row! Be ready for audits, financial inquiry, and full transparency of your financial records. Start with putting the data where it belongs, while bringing real-time visibility of your finances to outwit every question coming your way.",
          p2: "Simplify cash visibility across banks, accounts, subsidiaries and supply chain, with real time:",
          bullets: [
            "Payments",
            "Settlements",
            "Reconciliation",
            "Cash forecasts",
            "Reporting",
            "Accounting",
          ],
          p3: "See how we can hold your hands as you become a listed corporation in the use case for Thai corporates.",
        },
        franchise: {
          title: "Opening a Shop / Franchise",
          p1: "Opening a new business can be overwhelming. We can take some of the burden away by setting up your subscription based payments infrastructure. Use POS and EDC devices provided by our parent company, integrated with payment gateway. If you are a franchise owner, ensure you get your royalties paid first before the franchisee gets paid. Our virtual accounts and payment gateway solutions manage all of that for you seamlessly.",
        },
        realEstate: {
          title: "Real Estate",
          p1: "Ensure money is in the escrow before handing the keys - be it a seller or an owner renting a condo. Effectively manage all associated fees - maintenance, repairs, etc. integrated with the application of the real estate management.",
          p2: "Pay contractors seamlessly during construction through wallets - send notifications for any major updates, payments for daily wages etc. right into the contractor wallet. Run an ecosystem of money within your ecosystem.",
        },
        healthcare: {
          title: "Healthcare and Pharmaceuticals",
          p1: "Hospitals have permanent issues of queues at payment counters. Imagine having a hospital wallet where the patient can pay from. Imagine admitted patients being able to procure any ongoing services, procedures or even food within the hospital with the same wallet. Hospital staff and patients using the hospital wallet in the canteens and restaurants. Full visibility of earnings at canteens and restaurants to ensure the hospital is paid the rental percentage in full. All with a simple closed loop wallet, which can be white labeled for the hospital!",
          p2: "Pharmaceutical companies can manage their entire supply chain payments. Structure early/late payments depending on the need of the hour, in agreement with your suppliers with in-house banking solutions. Setup departmental budgets in designated virtual accounts with clear visibility of the cash utilization across board, while having an aggregated view at a group level. The possibilities of customizing the flow of payments with virtual accounts are endless.",
        },
      },
      sectionLabels: {
        automate: "Automate",
        reduce: "Reduce",
        achieve: "Achieve",
      },
    },
    contact: {
      label: "Get In Touch",
      title: "Contact Us",
      address: "Address",
      phone: "Phone",
      email: "Email",
      officeName: "IP PAYMENT SOLUTION CO., LTD. (HEAD OFFICE)",
      formLabel: "Contact Us",
      firstName: "First name",
      firstNamePlaceholder: "Your firstname",
      lastName: "Last name",
      lastNamePlaceholder: "Your lastname",
      emailPlaceholder: "your@email.com",
      companyWebsite: "Company Website",
      companyWebsitePlaceholder: "https://yourcompany.com",
      businessTypes: "Business Types",
      selectBusinessType: "Select a business type",
      solutionInterest: "Solution you're interested in",
      selectSolution: "Select a solution",
      message: "Message",
      messagePlaceholder: "Write your message here...",
      sending: "Sending...",
      submitSuccess: "Message sent successfully.",
      submitError: "Unable to send message. Please try again.",
      businessTypeOptions: [
        "Fund",
        "Construction",
        "Booking",
        "Tourism/Travel Agency",
        "Donations",
        "Electronic Donations",
        "Registration",
        "Education",
        "Gas and Fuel",
        "Transportation",
        "Public Utility Costs",
        "Jewelry (Diamonds, Gems)",
        "Cosmetics/Dietary Supplements",
        "Hire Purchase",
        "Purchasing Internet Hours",
        "Buying Products for Resale/Brand Name Products",
      ],
      solutionOptions: [
        "Treasury",
        "Virtual Accounts",
        "Invoice QR Integration",
        "E-Wallets",
        "B2B Payments",
        "Order to Cash",
        "Record to Report",
        "Cash Management",
        "Account Payables",
        "Other (please specify)",
      ],

      addressDetails:
        "199 S-OASIS Building, 11th Fl., Unit No. 1101, 1108, 1109, 1110 Vibhavadi-Rangsit Rd., Chom Phon, Chatuchak, Bangkok 10900, Thailand",
      general_inquiries: "General inquiries",
      customer_service: "Customer service",
      for_existing_customer: "for existing customer",
      job_applications: "Job applications",
    },
    footer: {
      whyUs: "Why Us",
      products: "Products",
      solutions: "Solutions",
      stayUpdated: "Stay Updated",
      subscribeDesc: "Subscribe to get the latest news and updates from IPPS.",
      emailPlaceholder: "Enter your email",
      copyright: "Copyright © 2024 IPPS. All rights reserved.",
      disclaimer: "Disclaimer",
      privacyPolicy: "Privacy Policy",
    },
  },
  th: {
    nav: {
      sections: {
        whyUs: "ทำไมต้องเรา",
        products: "ผลิตภัณฑ์",
        solutions: "โซลูชัน",
        resources: "แหล่งข้อมูล",
        contact: "ติดต่อเรา",
      },
      items: {
        ourCompany: "เกี่ยวกับบริษัท",
        ourMission: "พันธกิจของเรา",
        treasury: "บริหารเงินทุน",
        virtualAccounts: "บัญชีเสมือน",
        eWallets: "e-Wallet",
        invoiceQr: "รวมใบแจ้งหนี้-QR",
        b2bPayments: "การชำระเงิน B2B",
        orderToCash: "คำสั่งจ่ายเงิน",
        recordToReport: "บันทึกถึงรายงาน",
        cashManagement: "บริหารเงินสด",
        accountPayables: "เจ้าหนี้การค้า",
        useCases: "กรณีการใช้งาน",
      },
      openMenu: "เปิดเมนู",
      closeMenu: "ปิดเมนู",
      toggleLanguage: "สลับภาษา",
    },
    common: {
      product: "ผลิตภัณฑ์",
      talkToExpert: "คุยกับผู้เชี่ยวชาญ",
      contactUs: "ติดต่อเรา",
      writeMessage: "เขียนข้อความถึงเรา",
      sendMessage: "ส่งข้อความ",
      subscribe: "สมัครรับข่าวสาร",
    },
    banner: {
      slides: [
        "ไม่ต้องกังวลเรื่องกระแสเงินสดอีกต่อไป",
        "ชำระเงินได้อย่างไร้รอยต่อ",
        "ทำให้การจ่ายซัพพลายเชนอัตโนมัติ",
        "กระทบยอดได้ทันทีที่ทำรายการ",
        "ยกระดับสุขภาพทางการเงินองค์กร",
        "ทำธุรกรรมด้วยการเงินที่โปร่งใส",
      ],
      ctaTalk: "คุยกับผู้เชี่ยวชาญ",
      ctaProducts: "ดูผลิตภัณฑ์",
    },
    home: {
      sectionLabel: "สิ่งที่เราทำ",
      title:
        "โซลูชันครบวงจรสำหรับการชำระเงินองค์กร การรับชำระ เงินทุนหมุนเวียน และการบริหารเงินสด",
      desc1:
        "ได้รับความไว้วางใจจากหลายองค์กรให้ช่วยบริหารและทำธุรกรรมอัตโนมัติ ช่วยประหยัดทั้งเวลาและต้นทุนอย่างมีนัยสำคัญ",
      desc2:
        "โซลูชันของเราช่วยลดต้นทุนธุรกรรม ลดการทุจริต และทำให้คุณโฟกัสกับงานเชิงกลยุทธ์ได้เต็มที่",
      tabProducts: "ผลิตภัณฑ์",
      tabSolutions: "โซลูชัน",
      ctaUseCases: "กรณีความสำเร็จจากหลายอุตสาหกรรม",
      ctaTalk: "คุยกับผู้เชี่ยวชาญ",
      cards: {
        treasuryTitle: "บริหารเงินทุน",
        treasuryDesc: "บริหารธุรกิจด้วยความชัดเจนทางการเงินเต็มรูปแบบ",
        vaTitle: "บัญชีเสมือน",
        vaDesc: "ควบคุมการชำระเงินองค์กรแบบเรียลไทม์",
        invoiceTitle: "รวมใบแจ้งหนี้-QR",
        invoiceDesc: "กระทบยอดได้ทันทีที่ทำรายการ",
        walletsTitle: "e-Wallet",
        walletsDesc: "บริหารเจ้าหนี้และค่าใช้จ่ายได้ดีขึ้น",
        s1Title: "การชำระเงิน B2B",
        s1Desc: "Payment Gateway ระบบบริหารร้านค้า และบัญชีเสมือน",
        s2Title: "คำสั่งจ่ายเงิน",
        s2Desc: "รับชำระและกระทบยอดเร็วขึ้น ด้วยต้นทุนที่ต่ำลง",
        s3Title: "บันทึกถึงรายงาน",
        s3Desc: "ปิดบัญชีได้ไว กระทบยอดเรียลไทม์ พร้อมตรวจจับความผิดปกติ",
        s4Title: "บริหารเงินสด",
        s4Desc:
          "บริหารสถานะเงินสดรายวันอัตโนมัติ และเพิ่มประสิทธิภาพหนี้/การลงทุน",
        s5Title: "เจ้าหนี้การค้า",
        s5Desc:
          "ไม่พลาดการจ่ายเงิน เชื่อม ERP และจ่ายได้ทุกธนาคารจากพอร์ทัลเดียว",
      },
    },
    company: {
      label: "เกี่ยวกับบริษัท",
      title: "ทำให้เงินของคุณทำงานได้มากขึ้น",
      p1: "IP Payment Solutions เป็นผู้ให้บริการชำระเงินที่ได้รับใบอนุญาตจากธนาคารแห่งประเทศไทย ครอบคลุม e-money, bill payment, payment gateway และ e-money transfer ทำให้เราสามารถให้บริการบัญชีเอสโครว์ บริหารการรับจ่ายแทนลูกค้า และรวมการโอนระหว่างบัญชีได้อย่างครบวงจร",
      p2: "เราดำเนินงานด้วยมาตรฐานแบบสถาบันการเงิน ภายใต้การกำกับดูแลของธนาคารแห่งประเทศไทย เพื่อให้องค์กรเห็นข้อมูลธุรกรรมแบบโปร่งใสและกระทบยอดได้ทันที เป้าหมายของเราคือช่วยให้องค์กรเพิ่มประสิทธิภาพการทำงานและการตัดสินใจ ด้วยการมองเห็นกระแสเงินสดและการคาดการณ์เงินสดแบบเรียลไทม์",
    },
    mission: {
      label: "พันธกิจของเรา",
      title:
        "ทำให้การเงินซัพพลายเชนอัตโนมัติ และยกระดับกระบวนการ AR/AP ขององค์กรแบบดิจิทัล เพื่อให้ CFO โฟกัสกับกลยุทธ์การเติบโตของธุรกิจ",
      subtitle:
        "โซลูชันของเราสร้างประโยชน์ให้กับองค์กรทุกขนาดและทุกความซับซ้อน",
      benefits: [
        "ทำให้ AR และการกระทบยอดง่ายขึ้น",
        "เพิ่มประสิทธิภาพเงินทุนหมุนเวียน รับเงินจากลูกค้าปลายทางก่อน แล้วค่อยจ่ายต่อ",
        "เห็นภาพเงินสดรวมในที่เดียว เพื่อบริหารและคาดการณ์เงินสดได้ดีขึ้น",
        "ใช้เงินสดอย่างชาญฉลาด ด้วยการมองเห็นเงินสด 100% เพื่อวางแผนหนี้และการลงทุน",
        "ทำ AP ให้เรียบง่าย ด้วย workflow ครบวงจร รองรับทุกธนาคารในโซลูชันเดียว",
        "ลดค่าธรรมเนียมธนาคาร ด้วยระบบปิดลูปกับธนาคารพันธมิตร",
        "ลดงานปฏิบัติการ ด้วยการทำ GL/อนุมัติ/รายงานอัตโนมัติ",
      ],
    },
    products: {
      treasury: {
        title: "Treasury",
        subtitle: "บริหารธุรกิจด้วยความชัดเจนทางการเงินเต็มรูปแบบ",
        p1: "วันนี้คุณใช้กี่ธนาคาร มีกี่บัญชีในโครงสร้างบริษัท และต้องดึงข้อมูล AR/AP จากกี่ที่ ลองจินตนาการว่าข้อมูลทั้งหมดรวมอยู่ในที่เดียว พร้อมคาดการณ์แบบเรียลไทม์ คุณจะประหยัดเวลาและต้นทุนได้มากขึ้น พร้อมมองเห็นภาพรวมธุรกิจชัดเจนขึ้น",
        p2: "บัญชีเสมือนของเราเชื่อมกับระบบ treasury management ภายใต้ Flybridge รวมข้อมูลธนาคาร บัญชี รายการเคลื่อนไหว และ ERP ไว้ในที่เดียว ทำให้ทุกเช้าคุณเห็นกระแสเงินสดชัดเจนทันที",
      },
      virtualAccounts: {
        title: "บัญชีเสมือน",
        subtitle: "ควบคุมการชำระเงินองค์กรแบบเรียลไทม์",
        p1: "จัดการซัพพลายเชนบนระบบเดียวกัน ได้ความสามารถเหมือนบัญชีธนาคาร แต่มีรายละเอียดครบทุกธุรกรรมว่าใครจ่าย จ่ายอะไร เมื่อไร และเท่าไร",
        p2: "ทีมบัญชีไม่ต้องใช้เวลาหลายวันในการกระทบยอดอีกต่อไป คุณสามารถตั้ง workflow การชำระเงินจากผู้สร้างรายการ ไปผู้ตรวจ และผู้อนุมัติได้อัตโนมัติ",
        p3: "ลดความผิดพลาดและการทุจริต ด้วยการลดเอกสาร ลดการอนุมัติแบบกระจัดกระจาย และลดการรอคอย",
      },
      invoiceQr: {
        title: "Invoice QR Integration",
        subtitle: "รับชำระใบแจ้งหนี้และกระทบยอดได้ทันที",
        p1: "ส่งใบแจ้งหนี้พร้อม QR หรือลิงก์ชำระเงิน ทำให้การรับเงินมีข้อมูลอ้างอิงทุกครั้ง ลดเวลาติดตามลูกค้าและลดโอกาสพลาดการรับชำระ",
        p2: "จุดเด่นคือทุกการชำระมี reference ชัดเจน คุณรู้ได้ทันทีว่าใครจ่ายหรือยังไม่จ่าย ช่วยควบคุมกระแสเงินสดได้ดียิ่งขึ้น",
      },
      eWallets: {
        title: "E-Wallets",
        subtitle: "กระทบยอดได้ทันทีที่ทำรายการ",
        p1: "ทำธุรกรรมได้สะดวกขึ้น ทั้งเติมเงิน โอนเงิน ถอนเงิน ภายในระบบนิเวศของคุณ",
        p2: "โอนเงินให้พนักงานได้ในคลิกเดียว ไม่ต้องใช้เงินสดหรือเอกสารจำนวนมาก และสามารถส่งการแจ้งเตือนที่เกี่ยวข้องกับธุรกิจได้",
        p3: "ผู้ใช้งานทั่วไปสามารถชำระบิลและใช้งานบัญชีในไทยได้ง่ายขึ้น",
        p4: "เหมาะกับนักท่องเที่ยวที่ต้องการลดค่าธรรมเนียมจากการถอนเงินหรือใช้บัตร โดยยังสอดคล้องข้อกำกับของธนาคารแห่งประเทศไทย",
      },
    },
    solutions: {
      label: "สิ่งที่เรานำเสนอ",
      title: "โซลูชัน",
      b2b: {
        title: "การชำระเงิน B2B",
        p1: "Payment Gateway - เชื่อมการชำระเงินบนเว็บไซต์ อุปกรณ์ POS หรือ EDC ได้ง่าย ปลอดภัย และคุ้มค่า",
        p2: "Merchant Management System - บริหารการรับจ่าย การโอนเงิน และการกระทบยอดในอัตราที่แข่งขันได้ พร้อมมองเห็นธุรกรรมครบถ้วน",
        p3: "Virtual Accounts - โอนระหว่างบัญชีเสมือนในระบบ IPPS หรือโอนไปธนาคารอื่นได้ในคลิกเดียว",
      },
      orderToCash: {
        title: "คำสั่งจ่ายเงิน",
        subtitle: "ลดภาระหนี้ รับเงินได้มีประสิทธิภาพ",
        p1: "การรับชำระและกระทบยอดเร็วขึ้นในต้นทุนที่ต่ำลง ด้วยใบแจ้งหนี้ที่มี QR หรือลิงก์โอนเงินพร้อม reference",
        p2: "บริหารเครดิตลูกค้าได้ดีขึ้น ตั้งเงื่อนไขดอกเบี้ยหรือส่วนลดก่อนกำหนด และบันทึกรายการเข้าระบบบัญชีได้อัตโนมัติ",
      },
      recordToReport: {
        title: "บันทึกถึงรายงาน",
        subtitle: "ปิดบัญชีได้ในไม่กี่วันแทนที่จะเป็นหลายสัปดาห์",
        p1: "Financial close management - กระทบยอดบัญชีและสร้างรายงาน GL อัตโนมัติ ช่วยให้ปิดงบปลายเดือนได้เร็วขึ้น",
        p2: "Real-time reconciliation - การชำระพร้อม reference ทำให้รู้ทันทีว่าใครจ่ายค่าอะไร เมื่อไร",
        p3: "Anomaly management - ตรวจสอบและคัดกรองธุรกรรมผิดปกติด้วยกฎ/AI ลดการทุจริตอย่างมีนัยสำคัญ",
      },
      cashManagement: {
        title: "บริหารเงินสด",
        subtitle: "บริหารเงินทุนหมุนเวียนได้อย่างมืออาชีพ",
        p1: "ผู้บริหารการเงินต้องมองเห็นเงินสดทุกส่วนขององค์กรแบบเรียลไทม์ ทั้งบริษัทลูก แผนก ธนาคาร เจ้าหนี้ และลูกหนี้",
        p2: "สถานะเงินสดรายวันแบบอัตโนมัติ ช่วยเพิ่มผลิตภาพและตัดสินใจด้านหนี้/การลงทุนได้แม่นยำขึ้น",
      },
      accountPayables: {
        title: "เจ้าหนี้การค้า",
        p1: "กระจายอำนาจการจ่ายเงินพร้อมกำหนดสิทธิ์อนุมัติได้ชัดเจน โดยยังคงความโปร่งใสและควบคุมจากศูนย์กลาง เชื่อม ERP และจ่ายได้ทุกธนาคาร",
      },
    },
    usecases: {
      label: "อุตสาหกรรมที่เราโฟกัส",
      title: "กรณีการใช้งาน",
      subtitle:
        "ดูว่าโซลูชันการชำระเงินของเราช่วยเปลี่ยนธุรกิจในหลากหลายอุตสาหกรรมอย่างไร",
      list: {
        international: {
          title: "การรับจ่ายระหว่างประเทศ",
          p1: "รับเงินจากลูกค้าในไทยและจ่ายให้ซัพพลายเออร์ในไทยได้ แม้ไม่มีบัญชีธนาคารไทย ด้วยระบบบัญชีจาก IPPS",
          automate: [
            "การจ่ายซัพพลายเชน",
            "เงินเดือน",
            "หักภาษี",
            "คำสั่งจ่าย",
            "การกระทบยอด",
            "การคาดการณ์",
            "บัญชีแยกประเภท",
          ],
          reduce: ["ค่าธรรมเนียมธนาคาร", "ต้นทุนปฏิบัติการ", "การทุจริต"],
          achieve: [
            "ความโปร่งใส",
            "ประหยัดเวลา",
            "ประหยัดต้นทุน",
            "ความสามารถในการตัดสินใจเชิงกลยุทธ์",
            "ประโยชน์ด้าน ESG",
          ],
        },
        tourism: {
          title: "ท่องเที่ยวและโรงแรม",
          p1: "ให้ลูกค้าใช้ e-wallet ภายในรีสอร์ตหรือระบบนิเวศของคุณได้สะดวกยิ่งขึ้น",
          p2: "ตั้งกฎการจ่ายให้ซัพพลายเออร์อัตโนมัติ และอนุมัติ AP ได้รวดเร็ว",
        },
        finance: {
          title: "การเงินและสินเชื่อ",
          p1: "ผู้ให้กู้สามารถมั่นใจได้ว่าเงินในซัพพลายเชนปลอดภัย และเป็นผู้รับชำระลำดับแรก",
          p2: "บัญชีเสมือนช่วยให้เห็นการเคลื่อนไหวเงินครบถ้วน และตั้งกฎการรับชำระเข้า escrow ได้",
        },
        manufacturing: {
          title: "การผลิตและยานยนต์",
          p1: "บริหารการจ่ายเงินในซัพพลายเชนได้ต่อเนื่อง ตั้งเงื่อนไขจ่ายก่อน/หลัง และแบ่งงบตามหน่วยงานด้วยบัญชีเสมือน",
        },
        oil: {
          title: "น้ำมันและก๊าซ",
          p1: "รองรับการจ่ายเงินในพื้นที่ห่างไกล ด้วยระบบจ่ายเงินที่เชื่อมพันธมิตรข้ามพรมแดน",
        },
        retail: {
          title: "ค้าปลีกและสินค้าอุปโภคบริโภค",
          p1: "บริหารค่าเช่าจากร้านค้าในศูนย์ พร้อมเห็นธุรกรรมและยอดค้างชำระอย่างชัดเจน",
        },
        ecommerce: {
          title: "อีคอมเมิร์ซ",
          p1: "เชื่อม Payment Gateway รับชำระทุกช่องทาง และกระทบยอดแบบเรียลไทม์ด้วย reference",
        },
        transport: {
          title: "ขนส่งและโลจิสติกส์",
          p1: "รับเงินตามงานได้ทันที พร้อมใช้ wallet สำหรับจ่ายคนขับและค่าใช้จ่ายอื่นในระบบเดียว",
        },
        foreignWorker: {
          title: "แรงงานต่างชาติและเงินเดือน",
          p1: "ผู้ไม่มีบัญชีธนาคารสามารถเปิด wallet เพื่อรับ-จ่ายเงิน และรับเงินเดือนได้โดยตรง",
        },
        thaiCorp: {
          title: "องค์กรไทยและ Family Office",
          p1: "เห็นภาพเงินสดข้ามธนาคาร บัญชี และบริษัทลูกแบบเรียลไทม์:",
          bullets: [
            "การจ่ายเงิน",
            "การโอนเงิน",
            "การกระทบยอด",
            "คาดการณ์เงินสด",
            "รายงาน",
            "บัญชี",
          ],
        },
        ipo: {
          title: "เตรียมตัวเข้าตลาดหลักทรัพย์ (IPO)",
          p1: "จัดระบบข้อมูลการเงินให้พร้อมสำหรับการตรวจสอบและความโปร่งใสสูงสุด",
          p2: "ดูเงินสดทุกส่วนขององค์กรแบบเรียลไทม์:",
          bullets: [
            "การจ่ายเงิน",
            "การโอนเงิน",
            "การกระทบยอด",
            "คาดการณ์เงินสด",
            "รายงาน",
            "บัญชี",
          ],
          p3: "เราช่วยคุณเตรียมองค์กรให้พร้อมสู่การเป็นบริษัทจดทะเบียน",
        },
        franchise: {
          title: "เปิดร้าน / แฟรนไชส์",
          p1: "ช่วยวางระบบรับชำระแบบสมาชิก ใช้ POS/EDC เชื่อม payment gateway และบริหารค่าลิขสิทธิ์ได้อัตโนมัติ",
        },
        realEstate: {
          title: "อสังหาริมทรัพย์",
          p1: "ใช้ escrow ก่อนส่งมอบทรัพย์สิน และจัดการค่าใช้จ่ายที่เกี่ยวข้องได้ในระบบเดียว",
          p2: "จ่ายผู้รับเหมาได้สะดวกผ่าน wallet พร้อมแจ้งเตือนการจ่ายค่าแรงและอัปเดตงาน",
        },
        healthcare: {
          title: "สาธารณสุขและเภสัชกรรม",
          p1: "ลดคิวหน้าชำระเงินด้วย hospital wallet ให้คนไข้และบุคลากรใช้งานในระบบปิดได้",
          p2: "บริษัทเภสัชสามารถบริหารการจ่ายซัพพลายเชน ตั้งงบตามหน่วยงาน และติดตามเงินสดแบบรวมศูนย์",
        },
      },
      sectionLabels: {
        automate: "ทำให้อัตโนมัติ",
        reduce: "ลด",
        achieve: "บรรลุผล",
      },
    },
    contact: {
      label: "ติดต่อเรา",
      title: "ช่องทางติดต่อ",
      address: "ที่อยู่",
      phone: "โทรศัพท์",
      email: "อีเมล",
      officeName: "บริษัท ไอพี เพย์เมนท์ โซลูชั่น จำกัด (สำนักงานใหญ่)",
      formLabel: "ติดต่อเรา",
      firstName: "ชื่อ",
      firstNamePlaceholder: "ชื่อ",
      lastName: "นามสกุล",
      lastNamePlaceholder: "นามสกุล",
      emailPlaceholder: "your@email.com",
      companyWebsite: "เว็บไซต์บริษัท",
      companyWebsitePlaceholder: "https://yourcompany.com",
      businessTypes: "ประเภทธุรกิจ",
      selectBusinessType: "เลือกประเภทธุรกิจ",
      solutionInterest: "โซลูชันที่คุณสนใจ",
      selectSolution: "เลือกโซลูชัน",
      message: "ข้อความ",
      messagePlaceholder: "เขียนข้อความของคุณที่นี่...",
      sending: "กำลังส่ง...",
      submitSuccess: "ส่งข้อความสำเร็จ",
      submitError: "ส่งข้อความไม่สำเร็จ กรุณาลองอีกครั้ง",
      businessTypeOptions: [
        "กองทุน",
        "ก่อสร้าง",
        "การจอง",
        "ท่องเที่ยว/เอเจนซี่",
        "การบริจาค",
        "บริจาคอิเล็กทรอนิกส์",
        "ลงทะเบียน",
        "การศึกษา",
        "ก๊าซและเชื้อเพลิง",
        "ขนส่ง",
        "ค่าสาธารณูปโภค",
        "อัญมณี/เครื่องประดับ",
        "เครื่องสำอาง/อาหารเสริม",
        "เช่าซื้อ",
        "ซื้อชั่วโมงอินเทอร์เน็ต",
        "ซื้อสินค้าเพื่อนำไปขายต่อ/สินค้าแบรนด์",
      ],
      solutionOptions: [
        "บริหารเงินทุน",
        "บัญชีเสมือน",
        "รวมใบแจ้งหนี้-QR",
        "E-Wallets",
        "การชำระเงิน B2B",
        "คำสั่งจ่ายเงิน",
        "บันทึกถึงรายงาน",
        "บริหารเงินสด",
        "เจ้าหนี้การค้า",
        "อื่นๆ (โปรดระบุ)",
      ],

      addressDetails:
        "199 อาคาร เอสโอเอซิส ชั้น 11 ห้องเลขที่ 1101, 1108, 1109, 1110 ถนนวิภาวดีรังสิต แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900 ประเทศไทย",
      general_inquiries: "สอบถามเรื่องทั่วไป",
      for_existing_customer: "สำหรับลูกค้าปัจจุบัน",
      customer_service: "บริการลูกค้า",
      job_applications: "สมัครงาน",
    },
    footer: {
      whyUs: "ทำไมต้องเรา",
      products: "ผลิตภัณฑ์",
      solutions: "โซลูชัน",
      stayUpdated: "อัปเดตข่าวสาร",
      subscribeDesc: "สมัครเพื่อรับข่าวสารและอัปเดตล่าสุดจาก IPPS",
      emailPlaceholder: "กรอกอีเมลของคุณ",
      copyright: "ลิขสิทธิ์ © 2024 IPPS สงวนลิขสิทธิ์",
      disclaimer: "ข้อสงวนสิทธิ์",
      privacyPolicy: "นโยบายความเป็นส่วนตัว",
    },
  },
};
